import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ, IMAGES } from "../mock";
import { HelpCircle } from "lucide-react";

export default function Faq() {
  return (
    <section className="section-pad" style={{ background: "#f5f8fd" }}>
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center max-w-[720px] mx-auto mb-14">
          <h4>FAQ</h4>
          <h2>{FAQ.heading}</h2>
          <p>{FAQ.text}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-xl border border-white">
              <img
                src={IMAGES.dashboard}
                alt="Support"
                className="w-full h-[380px] object-cover"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <Accordion type="single" collapsible defaultValue="item-0" className="space-y-4">
              {FAQ.items.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="bg-white rounded-xl border border-slate-100 px-5 shadow-sm"
                >
                  <AccordionTrigger className="text-left text-[16px] font-semibold hover:no-underline py-5" style={{ color: "#141b34" }}>
                    <span className="flex items-center gap-3">
                      <HelpCircle size={20} className="text-[#1b6ef3] shrink-0" />
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] text-slate-500 leading-relaxed pb-5 pl-8">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
